<script lang="ts">
	import Comment from '$lib/Comment.svelte';
	import CommentForm from '$lib/CommentForm.svelte';
	import chatbubble from '$lib/assets/events/chatbubble.svg';
	import type { Infer, SuperValidated } from 'sveltekit-superforms';
	import type { schema } from './schemas/comment';

	interface Props {
		article: Populated<BaseArticle, never>;
		comments: BaseComment[];
		formData: SuperValidated<Infer<typeof schema>>;
	}

	let { article, comments, formData }: Props = $props();

	let replyTo: BaseComment | null = $state(null);
</script>

<section id="feedback" class="scroll-target mb-8">
	<header class="h3 mb-5 flex items-center justify-between">
		<div class="flex items-center">
			<img src={chatbubble} alt="chatbubble" class="mr-1" />
			{#if article.type === 'ProductReview'}
				Questions and Answers
			{:else}
				Comments
			{/if}
		</div>
		<p class="small-regular text-gray-mid">
			{comments.length}
			{article.type == 'ProductReview' ? 'questions' : 'comments'}
		</p>
	</header>
	<hr class="border-gray-light" />
	{#if comments.length}
		<ul class="mt-5 grid gap-4">
			{#each comments as comment}
				<li class="overflow-x-auto">
					<Comment
						type={article.type === 'ProductReview' ? 'question' : 'comment'}
						{comment}
						bind:replyTo
					/>
				</li>
			{/each}
		</ul>
	{/if}
</section>

<CommentForm
	documentId={article.documentId}
	{formData}
	{replyTo}
	type={article.type === 'ProductReview' ? 'question' : 'comment'}
/>
